import React from "react"
import styled, { keyframes } from "styled-components"

const List = ({ filter, items, paginate, perPage, Element, linkPrefix }) => {
  return items.length ? (
    <Style>
      {filter ? { filter } : null}

      <ul>
        {items.map((item, i) => (
          <li key={i}>
            <Element {...item} />
          </li>
        ))}
      </ul>
    </Style>
  ) : null
}

List.defaultProps = {
  paginate: true,
  perPage: 6,
  items: [],
  linkPrefix: null,
}

export default List

const Style = styled.div.attrs((props) => ({
  className: "content-list",
}))`
    animation-name: ${keyframes`
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    `}
    animation-delay: 0s;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    animation-iteration-count;


    > ul {
        list-style: none;
        padding: 0;
        margin: 0;

        > li {
            margin-bottom: 0;
            border-top: 1px ${(props) => props.theme.colors.silver} solid;
            padding-top: 2em;

            + li {
                margin-top: 2em;
            }
        }
    }
`
